import { parseEventLogs as viem_parseEventLogs, } from "viem";
/**
 * Parses logs and returns the corresponding events.
 * @param options - The options for parsing logs.
 * @returns The parsed events.
 * @example
 * ```ts
 * import { parseEventLogs } from "thirdweb";
 * const events = parseEventLogs({
 *  logs,
 *  events: [preparedEvent, preparedEvent2],
 * });
 * ```
 * @contract
 */
export function parseEventLogs(options) {
    const { logs, events, strict } = options;
    return viem_parseEventLogs({
        logs,
        abi: events.map((e) => e.abiEvent),
        strict,
    });
}
//# sourceMappingURL=parse-logs.js.map